import { useCallback } from "react";
import React from "react";
import { useSetAtom, useAtomValue } from "jotai";
import {
  CopilotUserMessage,
  executeZslAndSaveSetter,
  isExecutingZslAtom,
} from "@zapier/canvas-state";
import { Button } from "@zapier/design-system";
import { useConversationId } from "@zapier/ai-toolkit/client";

import styles from "../shared/buttonStyles.module.css";

export function BuildItButton() {
  const executeZslAndSave = useSetAtom(executeZslAndSaveSetter);
  const isExecuting = useAtomValue(isExecutingZslAtom);
  const conversationId = useConversationId();

  const handleButtonClick = useCallback(async () => {
    // Execute ZSL and transition to build mode
    await executeZslAndSave({
      conversationId,
      prompt: "", // Empty prompt for direct execution
      copilot: null, // No copilot context needed for direct build action
      onError: (errorMessage: string) => {
        // Send error message to trigger copilot help
        // ZSL execution completed successfully - no need to send message
        // The executeZslAndSave action will handle the state transition
        const message: CopilotUserMessage = {
          type: "COPILOT_USER_MESSAGE",
          payload: {
            source: "build_system",
            messageType: "error",
            message: errorMessage,
          },
        };
        window.postMessage(message, "*");
      },
    });
  }, [executeZslAndSave, conversationId]);

  return (
    <div className={styles.container}>
      <Button
        variant="primary"
        size="medium"
        onPress={handleButtonClick}
        isPending={isExecuting}
      >
        Build it
      </Button>
    </div>
  );
}
